import { RouteObject } from 'react-router-dom';
import { Departments } from '../Departments';
import { Geography } from '../../Geography';
import { CreateDepartments, EditDepartments } from '../pages';

const DepartmentsRoutes: RouteObject[] = [
  {
    path: 'geography',
    element: <Geography />,
  },
  {
    path: 'geography/departments',
    element: <Departments />,
  },
  {
    path: 'geography/departments/create',
    element: <CreateDepartments />,
  },
  {
    path: 'geography/departments/edit/:id',
    element: <EditDepartments />,
  },
];

export default DepartmentsRoutes;
